
import Confirm from 'vux/src/components/confirm/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Box from 'vux/src/components/box/index.vue'

export default {
data () {
return {
$vue: '', // 定义vue
name: '', // 姓名
mobile: '', // 手机
email: '', // 邮箱
idCard: '', // 省份证号码
isEdit: true,
position: 'bottom',
errorText: '',
showPositionValue: false,
ShowUpdateUserInfo: false, // 是否显示保存提交提示框
sex: ['男'],
sexOptions: [['男', '女']]
}
},
components: {
Confirm,
XInput,
Group,
Toast,
PopupPicker,
Flexbox,
FlexboxItem,
Box,
XButton
},
methods: {
/**
* @author      dongkuoji
* @description
* @date        2018/4/20 15:39
*/
save () {

this.$validator.validateAll().then((result) => {
if (!result) {

if (this.error.has('email')) {
this.showPosition(this.error.first('email'))
return
}

/* if (this.error.has('mobile')) {
this.showPosition(this.error.first('mobile'))
return
} */

if (this.error.has('idCard')) {
this.showPosition(this.error.first('idCard'))
return
}
}

this.ShowUpdateUserInfo = true
})
},
cancel () {
this.$router.go(-1)
/* this.$router.push({path: '/personinfo/personInfoDetail', query: {selected: '0'}}) */
},
showPosition (text) {
this.errorText = text
this.showPositionValue = true
},
/**
* @author      dongkuoji
* @description 修改个人信息
* @date        2018/4/20 15:40
*/
updateUserInfo () {
let params = new URLSearchParams()
params.append('NAME', this.name) 

if (this.sex[0] === '男') {
params.append('SEX', '1')
} else if (this.sex[0] === '女') {
params.append('SEX', '2')
}
params.append('EMAIL', this.email) 
params.append('RID', this.idCard) 
this.$http.post(this.$vue.getData('UPDATEPERSONINFO_URL'), params).then(suc => {
this.$router.push({path: '/personinfo/personInfoDetail'}) 
})
},
/**
* @author      dongkuoji
* @description 方法描述: 获取用户修改页面的个人信息
* @date        2018/5/9 14:31
*/
async getPersonInfoEdit () {
this.$http.post(this.$vue.getData('PERSONINFO_URL')).then(suc => {
let data = suc.data.data
this.name = data.USER_NAME 
this.mobile = data.PHONE 
this.idCard = data.RID 
this.email = data.EMAIL 
if (data.SEX === '1') {
this.sex = ['男']
} else if (data.SEX === '2') {
this.sex = ['女']
}
})
}
},
beforeMount () {
this.$vue = this
this.getPersonInfoEdit()
},
mounted () {
},
/**
* @author      dongkuoji
* @description 方法描述: 控制只有在个人信息详情页面时，才能进入修改页面，否则回到首页
* @date        2018/5/25 17:30
*/
beforeRouteEnter (to, from, next) {
if (from.name !== 'PersonInfoDetail') {
next({name: 'HomePage'})
} else {
next()
}
}
}



// WEBPACK FOOTER //
// ./src/components/doctor/user/personInfoEdit.vue